export const validateUser = (userdata) => {
  return userdata && userdata.project && !!userdata.project._id;;
};
